export const cardStackProducts = [
  {
    id: 1,
    name: "Meridian CRM",
    category: "Enterprise Software",
    price: "Custom",
    rating: 9.6,
    year: "2025",
    seasons: 3,
    items: 6,
    image: "https://readdy.ai/api/search-image?query=modern%20dark-themed%20CRM%20dashboard%20interface%20design%20on%20a%20large%20monitor%20screen%2C%20enterprise%20software%20UI%20with%20charts%20and%20analytics%2C%20dark%20background%20with%20warm%20amber%20accent%20colors%2C%20professional%20tech%20product%20photography%2C%20dramatic%20studio%20lighting%2C%20clean%20minimal%20interface%20design&width=320&height=420&seq=101&orientation=portrait",
  },
  {
    id: 2,
    name: "CloudSync Platform",
    category: "Cloud Solutions",
    price: "Custom",
    rating: 9.4,
    year: "2025",
    seasons: 2,
    items: 4,
    image: "https://readdy.ai/api/search-image?query=abstract%20cloud%20computing%20platform%20visualization%20with%20interconnected%20nodes%20and%20data%20streams%2C%20dark%20tech%20background%20with%20warm%20copper%20and%20orange%20glow%20accents%2C%20futuristic%20digital%20infrastructure%2C%20professional%203D%20render%2C%20dramatic%20lighting%2C%20minimal%20clean%20design&width=320&height=420&seq=102&orientation=portrait",
  },
  {
    id: 3,
    name: "MarketPulse AI",
    category: "Digital Marketing",
    price: "Custom",
    rating: 9.7,
    year: "2026",
    seasons: 2,
    items: 5,
    image: "https://readdy.ai/api/search-image?query=AI-powered%20digital%20marketing%20analytics%20dashboard%20with%20real-time%20data%20visualization%20graphs%2C%20growth%20metrics%20and%20campaign%20performance%20charts%2C%20dark%20interface%20with%20warm%20orange%20and%20red%20accent%20colors%2C%20professional%20tech%20product%20photography%2C%20moody%20dark%20background%2C%20clean%20UI%20design&width=320&height=420&seq=103&orientation=portrait",
  },
  {
    id: 4,
    name: "SecureVault",
    category: "Cybersecurity",
    price: "Custom",
    rating: 9.2,
    year: "2025",
    seasons: 1,
    items: 3,
    image: "https://readdy.ai/api/search-image?query=cybersecurity%20shield%20and%20lock%20visualization%20on%20dark%20background%20with%20glowing%20network%20protection%20layers%2C%20digital%20security%20concept%20with%20warm%20amber%20and%20copper%20light%20accents%2C%20professional%20tech%20product%20photography%2C%20futuristic%20data%20protection%20interface%2C%20dramatic%20studio%20lighting&width=320&height=420&seq=104&orientation=portrait",
  },
  {
    id: 5,
    name: "DevStream IDE",
    category: "Development Tools",
    price: "Custom",
    rating: 9.0,
    year: "2024",
    seasons: 2,
    items: 4,
    image: "https://readdy.ai/api/search-image?query=modern%20code%20editor%20and%20development%20environment%20interface%20on%20dark%20screen%20with%20syntax%20highlighting%2C%20software%20development%20IDE%20with%20multiple%20panels%20and%20terminal%2C%20warm%20amber%20accent%20colors%20on%20dark%20background%2C%20professional%20tech%20product%20photography%2C%20clean%20minimal%20design%2C%20dramatic%20lighting&width=320&height=420&seq=105&orientation=portrait",
  },
  {
    id: 6,
    name: "DataFlow Analytics",
    category: "Business Intelligence",
    price: "Custom",
    rating: 9.3,
    year: "2025",
    seasons: 1,
    items: 2,
    image: "https://readdy.ai/api/search-image?query=business%20intelligence%20data%20analytics%20dashboard%20with%20flowing%20data%20streams%20and%20real-time%20charts%2C%20dark%20background%20with%20warm%20copper%20and%20red%20glowing%20data%20visualizations%2C%20professional%20tech%20product%20photography%2C%20futuristic%20big%20data%20interface%2C%20dramatic%20studio%20lighting%2C%20clean%20minimal%20design&width=320&height=420&seq=106&orientation=portrait",
  },
  {
    id: 7,
    name: "BrandBuilder Suite",
    category: "Brand Management",
    price: "Custom",
    rating: 9.1,
    year: "2024",
    seasons: 2,
    items: 3,
    image: "https://readdy.ai/api/search-image?query=brand%20management%20platform%20interface%20with%20social%20media%20scheduling%20and%20content%20calendar%20dashboard%2C%20dark%20UI%20with%20warm%20orange%20accent%20colors%2C%20professional%20marketing%20software%20product%20photography%2C%20moody%20dark%20background%2C%20clean%20modern%20design%2C%20dramatic%20lighting&width=320&height=420&seq=107&orientation=portrait",
  },
];

export const features = [
  {
    icon: "ri-code-box-line",
    title: "Custom Software Development",
    description: "We build tailored software solutions from the ground up — web applications, mobile apps, enterprise systems, and SaaS platforms designed to fit your exact business needs.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "IT Consulting",
    description: "Our consultants help businesses make informed technology decisions, optimize processes, and implement modern tools that drive growth and operational efficiency.",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "Digital Marketing & Advertising",
    description: "We develop comprehensive promotion strategies, strengthen brand presence, and help products find their audience — combining technology and marketing into a unified growth strategy.",
  },
];

export const collections = [
  { label: "All", value: "all" },
  { label: "Enterprise", value: "enterprise" },
  { label: "Cloud", value: "cloud" },
  { label: "Marketing", value: "marketing" },
  { label: "Security", value: "security" },
];

export const products = [
  {
    id: 1,
    name: "Meridian CRM",
    category: "Enterprise",
    price: "Custom Quote",
    badge: "Popular",
    image: "https://readdy.ai/api/search-image?query=modern%20CRM%20dashboard%20interface%20with%20customer%20data%20cards%20and%20sales%20pipeline%20visualization%2C%20dark%20themed%20enterprise%20software%20UI%2C%20warm%20amber%20accent%20colors%2C%20professional%20tech%20product%20photography%2C%20clean%20minimal%20design%2C%20soft%20studio%20lighting&width=300&height=375&seq=201&orientation=portrait",
  },
  {
    id: 2,
    name: "MarketPulse AI",
    category: "Marketing",
    price: "Custom Quote",
    badge: "New",
    image: "https://readdy.ai/api/search-image?query=AI%20marketing%20analytics%20dashboard%20with%20campaign%20performance%20metrics%20and%20audience%20insights%2C%20dark%20interface%20with%20warm%20orange%20accents%2C%20professional%20tech%20product%20photography%2C%20clean%20modern%20design%2C%20soft%20studio%20lighting&width=300&height=375&seq=202&orientation=portrait",
  },
  {
    id: 3,
    name: "CloudSync Platform",
    category: "Cloud",
    price: "Custom Quote",
    badge: "",
    image: "https://readdy.ai/api/search-image?query=cloud%20infrastructure%20management%20dashboard%20with%20server%20nodes%20and%20deployment%20visualization%2C%20dark%20tech%20interface%20with%20warm%20copper%20accents%2C%20professional%20product%20photography%2C%20clean%20minimal%20design%2C%20soft%20studio%20lighting&width=300&height=375&seq=203&orientation=portrait",
  },
  {
    id: 4,
    name: "SecureVault",
    category: "Security",
    price: "Custom Quote",
    badge: "New",
    image: "https://readdy.ai/api/search-image?query=cybersecurity%20monitoring%20dashboard%20with%20threat%20detection%20alerts%20and%20network%20status%2C%20dark%20UI%20with%20red%20and%20amber%20warning%20indicators%2C%20professional%20tech%20product%20photography%2C%20clean%20modern%20design%2C%20soft%20studio%20lighting&width=300&height=375&seq=204&orientation=portrait",
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "Trevionix transformed our entire digital infrastructure. Their team delivered a custom CRM that increased our sales team productivity by 40%. The communication was transparent throughout the entire project.",
    name: "Sarah Mitchell",
    title: "COO, Vertex Logistics",
    image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20businesswoman%20in%20her%2030s%20wearing%20a%20blazer%2C%20warm%20natural%20window%20light%2C%20soft%20neutral%20office%20background%2C%20approachable%20and%20professional%20expression%2C%20headshot%20photography&width=400&height=520&seq=301&orientation=portrait",
  },
  {
    id: 2,
    quote: "As a startup founder, I needed a tech partner who could move fast without cutting corners. Trevionix built our MVP in 8 weeks and helped us secure our seed round. Their consulting insights were invaluable.",
    name: "Marcus Webb",
    title: "Founder, Nexa Finance",
    image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20man%20tech%20entrepreneur%20in%20his%2040s%2C%20warm%20natural%20light%2C%20soft%20neutral%20background%2C%20serious%20and%20thoughtful%20expression%2C%20headshot%20photography&width=400&height=520&seq=302&orientation=portrait",
  },
  {
    id: 3,
    quote: "Their digital marketing team took our brand from virtually unknown to a recognized name in our industry. The results speak for themselves — 300% increase in qualified leads within six months.",
    name: "Diana Flores",
    title: "CMO, Elevate Retail",
    image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20latina%20woman%20marketing%20executive%20in%20her%2030s%2C%20warm%20natural%20light%2C%20soft%20neutral%20background%2C%20confident%20warm%20smile%2C%20headshot%20photography&width=400&height=520&seq=303&orientation=portrait",
  },
];

export const teamAvatars = [
  "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20male%20tech%20project%20manager%2C%20warm%20sepia%20tone%2C%20neutral%20background%2C%20artistic%20lighting%2C%20confident%20expression&width=56&height=56&seq=401&orientation=squarish",
  "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20female%20software%20developer%2C%20warm%20sepia%20tone%2C%20neutral%20background%2C%20artistic%20lighting%2C%20confident%20expression&width=56&height=56&seq=402&orientation=squarish",
  "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20male%20UI%20UX%20designer%2C%20warm%20sepia%20tone%2C%20neutral%20background%2C%20artistic%20lighting%2C%20creative%20expression&width=56&height=56&seq=403&orientation=squarish",
  "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20female%20digital%20marketing%20specialist%2C%20warm%20sepia%20tone%2C%20neutral%20background%2C%20artistic%20lighting%2C%20friendly%20expression&width=56&height=56&seq=404&orientation=squarish",
];